import { connect, ConnectedProps } from "react-redux";
import { withRouter } from "react-router";
import {
  fetchTravelWalletCreditHistory,
  fetchTravelWalletDetails,
} from "../../modules/travel-wallet/actions/actions";
import {
  getActiveTravelWalletOffers,
  getFetchTravelWalletDetailsCallState,
  getTravelWalletCredit,
  getTravelWalletOffers,
} from "../../modules/travel-wallet/reducer";
import { IStoreState } from "../../reducers/types";
import { TravelWalletLanding } from "./component";
import { getAreOfferDetailsLoading } from "./reducer";
import { fetchRewardsAccounts } from "../../modules/rewards/actions/actions";
import { getFetchRewardsAccountsCallState } from "../../modules/rewards/reducer";

const mapStateToProps = (state: IStoreState) => ({
  allOffers: getTravelWalletOffers(state),
  activeOffers: getActiveTravelWalletOffers(state),
  credit: getTravelWalletCredit(state),
  areOfferDetailsLoading: getAreOfferDetailsLoading(state),
  rewardsAccountsCallState: getFetchRewardsAccountsCallState(state),
  walletDetailsCallState: getFetchTravelWalletDetailsCallState(state),
});

const mapDispatchToProps = {
  fetchTravelWalletDetails,
  fetchTravelWalletCreditHistory,
  fetchRewardsAccounts,
};

const connector = connect(mapStateToProps, mapDispatchToProps);

export type TravelWalletLandingConnectorProps = ConnectedProps<
  typeof connector
>;

export const ConnectedTravelWalletLanding = connector(
  withRouter(TravelWalletLanding),
);
